const HOUR_MS = 60 * 60 * 1000;
const TWELVE_H_MS = 12 * HOUR_MS;
const TWENTY_FOUR_H_MS = 24 * HOUR_MS;

/** @typedef {"fresh"|"aging"|"late"} TimingLevel */

export const TIMING_LEVELS = {
  fresh: {
    id: "fresh",
    label: "< 12h",
    face: "😊",
    bg: "rgba(56, 161, 105, 0.12)",
    color: "#276749",
  },
  aging: {
    id: "aging",
    label: "12–24h",
    face: "😕",
    bg: "rgba(214, 158, 46, 0.14)",
    color: "#975A16",
  },
  late: {
    id: "late",
    label: "> 24h",
    face: "😠",
    bg: "rgba(155, 44, 44, 0.12)",
    color: "#9B2C2C",
  },
};

export const ASSISTANT_POINTS = {
  fresh: 5,
  aging: 6,
  late: 7,
};

export function hasSubmittedPdf(row) {
  return row?.student_pdf != null && String(row.student_pdf).trim() !== "";
}

export function getSubmittedAt(row) {
  return row?.submitted_at ?? row?.created_at;
}

/** @returns {TimingLevel|null} */
export function getSubmissionTimingLevel(row) {
  const submittedAt = getSubmittedAt(row);
  if (!submittedAt) return null;
  const ageMs = Date.now() - new Date(submittedAt).getTime();
  if (Number.isNaN(ageMs) || ageMs < 0) return "fresh";
  if (ageMs < TWELVE_H_MS) return "fresh";
  if (ageMs < TWENTY_FOUR_H_MS) return "aging";
  return "late";
}

export function getAssistantPoints(row) {
  const level = getSubmissionTimingLevel(row);
  return ASSISTANT_POINTS[level] ?? ASSISTANT_POINTS.fresh;
}

export function formatSubmittedAt(value) {
  if (!value) return "N/A";
  const date = new Date(value);
  return date
    .toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })
    .replace(",", "");
}
